export default import.meta.ROLLDOWN_FILE_URL_w3$kZ6HT7OGRkxfr9TIcDQ